module.exports = __webpack_public_path__ + "static/img/stamp_close.d81b6eba.png";